import { configureStore } from "@reduxjs/toolkit";

import toastSlice from "./toastSlice";

export default configureStore({
  reducer: {
    toastSlice: toastSlice,
  },
});
